import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=a5987d7e&scoped=true&"
import script from "./ExportData.vue?vue&type=script&lang=js&"
export * from "./ExportData.vue?vue&type=script&lang=js&"
import style0 from "./ExportData.vue?vue&type=style&index=0&id=a5987d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5987d7e",
  null
  
)

export default component.exports